// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1uppr","footer":"ReportModalFilter_footer__3Rba9"};